"use client";

import React from "react";
import styles from "./layout.module.scss";
import { auth } from "@/auth";
import { redirect } from "next/navigation";
import { useCurrentUser } from "@/hooks/use-current-user";

const AuthLayout = ({ children }: any) => {
  const user = useCurrentUser();
  if (user) {
    redirect("/");
  }
  return <main className={styles.main}>{children}</main>;
};

export default AuthLayout;
